import { DeleteButton } from '@/core/components';

import { Id, useDelete } from '@feature/utils';

import { useGovEvalMinStdDelete } from '../model/GovEvaluationQuery';

interface GovEvalMinStdDeleteButtonProps {
  evaluationId: Id;
  disabled?: boolean;
}

export function GovEvalMinStdDeleteButton({ evaluationId, disabled }: GovEvalMinStdDeleteButtonProps) {
  const mutation = useGovEvalMinStdDelete(evaluationId);
  const deleteProps = useDelete({
    mutation,
    navigateTo: { to: '.' },
  });

  return (
    <DeleteButton
      miw="100px"
      size="xs"
      disabled={disabled}
      {...deleteProps}
    />
  );
}
